export enum NativeMessages {
  DeepLink = "deeplink",
  DidTapClose = "didTapClose",
  DidTapShare = "didTapShare",
  Loaded = "loaded",
}
